import { getMeetingStatusLabel as resolveMeetingStatusLabel } from '@utils/referenceCatalog';

/**
 * Status labels mapping for consistent display across the application
 */
export const STATUS_LABELS: { [key: string]: string } = {
  pending_data_enrichment: 'Pending CO/CM',
  reassessment_due: 'Reassessment Due',
  ready_for_scheduling: 'Ready for Scheduling',
  scheduled: 'Scheduled',
  rescheduled: 'Rescheduled',
  completed: 'Completed'
};

/**
 * Get human-readable label for a status
 */
export const getStatusLabel = (status: string): string => {
  return STATUS_LABELS[status] || status.replace(/_/g, ' ');
};

/**
 * Status colors for consistent styling
 */
export const STATUS_COLORS: { [key: string]: string } = {
  pending_data_enrichment: '#f59e0b',
  ready_for_scheduling: '#3b82f6',
  scheduled: '#f97316'
};

/**
 * Get color for a status
 */
export const getStatusColor = (status: string): string => {
  return STATUS_COLORS[status] || '#6b7280';
};

/**
 * Meeting status labels mapping for consistent display
 * Maps backend status (lowercase/underscore) to AssessmentStatus format (Title Case)
 */
export const MEETING_STATUS_LABELS: { [key: string]: string } = {
  pending: 'Pending Scheduling',
  scheduled: 'Scheduled',
  rescheduled: 'Rescheduled',
  completed: 'Closed',
  cancelled: 'Cancelled',
  not_scheduled: 'Not Scheduled'
};

/**
 * Get human-readable label for a meeting status
 * Converts backend format to Badge-compatible format
 */
export const getMeetingStatusLabel = (status: string): string => {
  return resolveMeetingStatusLabel(status);
};
